export const styledReportDashboard = () => /* css */`

@page {
    margin: 0mm;
}

.header-report,
.footer-report,
.line-divider {
    display: flex !important;
}

.header-report {
    display: flex !important;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    height: 120px;
    padding-left: 15mm;
    padding-right: 15mm;
    box-sizing: border-box;
    width: 100%;
}

.footer-report {
    width: 100%;
    text-align: center;
    position: fixed;
    bottom: 0;
    left: 0;
}

.footer-report,
.footer-report-img {
    z-index: -1;
    height: 250px;
    margin-bottom: -1px;
}

.footer-report-logo-img {
    position: absolute;
    z-index: 1000;
    bottom: 0;
    margin-bottom: 50px;
    padding: 15px;
    margin-left: 15mm;
    max-height: 90px;
    max-width: 180px;
    object-fit: contain;
}

.footer-report-date-generated {
    padding: 5px 0;
    text-align: center;
    width: 100%;
    font-size: 12px;
    z-index: 1000;
    bottom: 0;
    position: absolute;
}

.footer-report-date-generated > p {
    color: #fff;
    margin-bottom: 22px;
    font-size: 13px;
}

.page {
    page-break-before: always;
    break-before: page;
    page-break-inside: avoid;
    break-inside: avoid;
}

.page-first {
    page-break-before: auto !important;
    break-before: auto !important;
}

.header-info {
    flex: 1;
    min-width: 0;
    padding-right: 16px;
}

.header-info h1 {
    font-size: 1.4rem;
    font-weight: 700;
    color: #1e293b;
    margin: 0 0 2px 0;
    line-height: 1.2;
}

.header-info .header-city {
    font-size: 1rem;
    color: #475569;
    margin: 0 0 3px 0;
    font-weight: 500;
}

.header-info .header-filter {
    font-size: 0.85rem;
    color: #64748b;
    margin: 0;
    line-height: 1.3;
}

.header-info .filter-label {
    font-weight: 600;
    color: #334155;
}

.header-info .filter-value {
    color: #1677ff;
    font-weight: 600;
}

.header-logo {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.header-logo img {
    max-width: 170px;
    max-height: 75px;
    object-fit: contain;
}

@media print {
    body {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
        margin: 0mm;
    }

    .header-report {
        display: flex !important;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 120px;
        padding-left: 15mm;
        padding-right: 15mm;
        box-sizing: border-box;
        align-items: center;
        justify-content: space-between;
        background: #ffffff;
        z-index: 100;
    }

    .header-info h1 {
        margin-top: 0;
        font-size: 1.4rem;
    }

    .header-logo img {
        margin-right: 0;
    }

    .footer-report {
        display: block !important;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
    }

    .page {
        padding-top: 130px;
        padding-bottom: 180px;
        box-sizing: border-box;
        page-break-before: always;
        break-before: page;
        page-break-inside: avoid;
        break-inside: avoid;
    }

    .page-first {
        padding-top: 0;
        padding-bottom: 200px;
        page-break-before: auto !important;
        break-before: auto !important;
    }

    .page:not(.page-first)::before {
        content: '';
        display: block;
        border-bottom: 1px solid #e2e8f0;
        margin-bottom: 16px;
        margin-left: 15mm !important;
        margin-right: 15mm !important;
    }

    .line-divider {
        margin-top: 125px;
        margin-bottom: 16px;
        border-bottom: 1px solid #e2e8f0;
        display: block;
        margin-left: 15mm !important;
        margin-right: 15mm !important;
    }

    .section-report {
        margin-left: 15mm !important;
        margin-right: 15mm !important;
    }

    .section-title {
        font-size: 16px !important;
        margin-bottom: 16px !important;
        color: #2c3e50 !important;
    }

    .section-text {
        color: #251E1E !important;
    }

    .section-label {
        color: #6c757d !important;
    }

    .report-card {
        background: rgb(248, 250, 253) !important;
        border: 1px solid #e2e8f0 !important;
        border-radius: 6px !important;
        break-inside: avoid;
        page-break-inside: avoid;
    }

    .info-item {
        background: #ffffff !important;
        border-radius: 4px !important;
    }

    .chart-report-wrapper {
        break-inside: avoid;
        page-break-inside: avoid;
    }

    .dashboard-table,
    .dashboard-table .ant-table,
    .dashboard-table .ant-table-tbody > tr > td,
    .dashboard-table .ant-table-thead > tr > th {
        background: #ffffff !important;
        color: #1a1a1a !important;
        border-color: #e8e8e8 !important;
        padding: 6px 10px !important;
        font-size: 13px !important;
        line-height: 1.35 !important;
    }

    .dashboard-table .ant-table-thead > tr > th {
        background: #fafafa !important;
        font-weight: 600 !important;
        padding: 8px 10px !important;
        font-size: 13px !important;
    }

    .dashboard-table .ant-table-tbody > tr:nth-child(even) > td {
        background: #f9f9f9 !important;
        border-radius: 6px;
    }

    .dashboard-table .ant-table-cell {
        color: #1a1a1a !important;
    }

    .ant-card-extra {
        display: none !important;
    }

    .chart-report-wrapper .ant-card {
        zoom: 0.95;
        background: rgb(248, 250, 253) !important;
        box-shadow: 0 3px 8px rgba(0,0,0,0.08) !important;
        border-radius: 6px !important;
    }

    .chart-report-wrapper .ant-card-head,
    .chart-report-wrapper .ant-card-head-title,
    .chart-report-wrapper .ant-card-head-wrapper,
    .report-card .ant-card-head,
    .report-card .ant-card-head-title,
    .report-card .ant-card-head-wrapper {
        color: #1a1a1a !important;
        background: rgb(248, 250, 253) !important;
        border-bottom-color: #e8e8e8 !important;
    }

    .invoices-type-report-wrapper .ant-card {
        zoom: 0.95;
    }

    .chart-report-wrapper svg {
        overflow: visible !important;
    }
}

.report-card {
    border-radius: 6px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.08);
    font-family: Arial, sans-serif;
}

.chart-report-wrapper {
    margin-bottom: 20px;
}

.section-label {
    font-size: 12px;
    color: #6c757d;
    letter-spacing: 0.05em;
    margin-bottom: 10px;
    font-weight: 500;
}

.logo-img {
    max-height: 150px;
    max-width: 250px;
    object-fit: contain;
}
`;
